import { POST, GET } from 'src/network/apiHandler';
import config from 'src/globals';
import {
  CREATE_VENDOR_USER,
  DOWNLOAD_VENDOR_USERS,
  GET_VENDOR_USERS,
  UPDATE_VENDOR_USER,
  GET_ROLES_WITH_PERMISSIONS,
  SEARCH_HUBS,
} from 'src/api/routes';

const { API_BASE_URL } = config;

export const createVendorUser = async (data: any) => {
  return POST(`${API_BASE_URL}${CREATE_VENDOR_USER}`, data);
};

export const fetchVendorUsers = async (params?: Record<string, any>) => {
  return GET(`${API_BASE_URL}${GET_VENDOR_USERS}`, params);
};

export const updateVendorUser = async (data: any) => {
  return POST(`${API_BASE_URL}${UPDATE_VENDOR_USER}`, data);
};

export const downloadVendorUsers = async (params?: Record<string, any>) => {
  return GET(`${API_BASE_URL}${DOWNLOAD_VENDOR_USERS}`, params, 'blob');
};

export const fetchRolesAndPermissions = async () => {
  return GET(`${API_BASE_URL}${GET_ROLES_WITH_PERMISSIONS}`);
};

export const searchVendorHubs = async (queryStr: string) => {
  return GET(`${API_BASE_URL}${SEARCH_HUBS}`, { queryStr: queryStr || '' });
};

export interface HubRef {
  id: string;
  code: string;
  name: string;
}

// Normalises a vendor user's hubs field, which the backend may return either as a
// resolved [{id, code, name}] array or as bare hub_ids.
export const resolveUserHubs = (user: any): HubRef[] => {
  if (Array.isArray(user?.hubs)) {
    return user.hubs.map((h: any) => ({
      id: String(h.id),
      code: h.code,
      name: h.name || '',
    }));
  }
  if (Array.isArray(user?.hub_ids)) {
    return user.hub_ids.map((id: any) => ({
      id: String(id),
      code: String(id),
      name: '',
    }));
  }
  return [];
};

export const getUserPermissions = (
  userRoles: string[] = [],
  rolePermissions: Record<string, string[]> = {},
): string[] => {
  const set = new Set<string>();
  (userRoles || []).forEach((role) => {
    (rolePermissions[role] || []).forEach((p) => set.add(p));
  });
  return Array.from(set).sort();
};

export interface RolesAndPermissionsResponse {
  VENDOR_ROLES: string[];
  ROLE_PERMISSIONS: Record<string, string[]>;
}

/**
 * Fetches roles and permissions from the API
 * @returns Promise with VENDOR_ROLES array and ROLE_PERMISSIONS object
 */
export const getRolesAndPermissions = async (): Promise<RolesAndPermissionsResponse> => {
  const response = await fetchRolesAndPermissions();

  return {
    VENDOR_ROLES: response.data.roles || [],
    ROLE_PERMISSIONS: response.data.rolePermissions || {},
  };
};
